import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {Observable, of} from "rxjs";
import {Injectable} from "@angular/core";
import {AuthService} from "../services/auth.service";

@Injectable({
   providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild{


  constructor(
    private router: Router,
    private auth: AuthService){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
 	if(this.auth.userDataLoaded){
	return this.auth.isAdmin()

	}else{
	 this.router.navigate(['/overview'],{
		queryParams:{
		 // accessDenied: true
		}
	      })
	      return of(false)
		
	}
 /*
    if(this.auth.role === 'Admin'){
      return of(true)
    }else {
      this.router.navigate(['/overview'],{
        queryParams:{
         // accessDenied: true
        }
      })
      return of(false)
    } */
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    return this.canActivate(route, state)
  }

}
